export enum TranslationType {
    Unknown = 0,
    Web = 1,
    Backend = 2,
    Mobile = 5,
    Email = 11
}